import { AriaAttributes } from "react";
import { PORTFOLIO_TABLE_FIRST_SORT_DIRECTION } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-constants";
import { Sorting } from "src/components-mui/pages/detail/portfolio-table-section/sort-utils";
import { SortDirection } from "src/constants/sort-direction";
import { getAriaSort } from "src/utils/table/get-aria-sort";

/**
 * `compareNumber` and `compareString` treat `SortDirection.Descending` as smallest first (A to Z),
 * so the direction stored in `Sorting` is the opposite of the order the user sees.
 */
const getVisibleOrder = (direction: Sorting["direction"]): SortDirection =>
    direction === SortDirection.Descending ? SortDirection.Ascending : SortDirection.Descending;

export const getNextSortDirection = (isActive: boolean, direction: Sorting["direction"]): Sorting["direction"] => {
    if (!isActive) {
        return PORTFOLIO_TABLE_FIRST_SORT_DIRECTION;
    }

    return direction === SortDirection.Ascending ? SortDirection.Descending : SortDirection.Ascending;
};

export const getColumnAriaSort = (isActive: boolean, direction: Sorting["direction"]): AriaAttributes["aria-sort"] =>
    getAriaSort(isActive && getVisibleOrder(direction));

export const getColumnSortAriaLabelKey = (isActive: boolean, direction: Sorting["direction"]) => {
    if (!isActive) {
        return "sort-column";
    }

    return direction === SortDirection.Descending ? "sort-column-asc" : "sort-column-desc";
};
